export const MENU_ROLES = Object.freeze({
  MENU: "menu",
  LIST: "list",
  LISTBOX: "listbox",
} as const);
export const MENU_ITEM_ROLES = Object.freeze({
  MENUITEM: "menuitem",
  LISTITEM: "listitem",
  OPTION: "option",
  RADIO: "menuitemradio",
  CHECKBOX: "menuitemcheckbox",
} as const);
